import { Page } from 'react-pdf';

import { HighlightCanvas } from '../highlight-canvas';
import { DocViewerLoader } from './doc-viewer-loader';
import { BoundingBoxWithId } from '@/types';

interface PDFPageProps {
  pageNumber: number;
  top: number;
  dimensions: { width: number; height: number };
  onLoadSuccess: (page: { width: number; height: number }) => void;
  pdfCanvas: HTMLCanvasElement | null;
  highlights: BoundingBoxWithId[];
  onHighlightClick?: (id: string) => void;
  highlightedFactId?: string | null;
  highlightedChunkId?: string | null;
}

export const PDFPage = ({
  pageNumber,
  top,
  dimensions,
  onLoadSuccess,
  pdfCanvas,
  highlights,
  highlightedFactId,
  onHighlightClick,
  highlightedChunkId,
}: PDFPageProps) => {
  return (
    <div
      className="absolute shadow-lg"
      style={{
        top,
        left: '50%',
        transform: 'translateX(-50%)',
        width: dimensions.width,
      }}
    >
      <HighlightCanvas
        highlights={highlights}
        pageNumber={pageNumber}
        width={dimensions.width}
        height={dimensions.height}
        highlightedFactId={highlightedFactId}
        onHighlightClick={onHighlightClick}
        highlightedChunkId={highlightedChunkId}
      />
      <Page
        pageNumber={pageNumber}
        canvasRef={(ref) => (pdfCanvas = ref)}
        width={dimensions.width}
        height={dimensions.height}
        onLoadSuccess={(page) => onLoadSuccess(page)}
        renderTextLayer={false}
        renderAnnotationLayer={false}
        loading={<DocViewerLoader />}
      />
    </div>
  );
};
